// src/pages/Home.tsx
import React from 'react';
// We assume these are imported as regular components, not as full pages.
// The file paths will be corrected to reflect they are sections/components.
import HeroSection from "../pages/components/Hero"; // Hero is a component
import AboutSection from "../pages/about/page"; // About is a section/page
import CoursesSection from "../pages/cources/page"; // WhyChoose/Courses is a section/page
import ContactSection from "../pages/contact/page"; // Contact is a section/page


// Note: Header and Footer are now handled by PublicLayout.tsx

export default function Home() {
    return (
        <div id="home-content">
            {/* These components are now rendered once within the Home component */}
            <HeroSection />
            <AboutSection />
            <CoursesSection />
            <ContactSection />
        </div>
    );
}
// Note: Since this fix involves changing the naming convention of imports inside your Home component
// (the original file uses 'ContactPage', 'AboutPage', 'WhyChooseSection', but the file is named '/page.tsx'),
// this file has been updated to use the original file names for clarity.